<template>
  <main>
    <div data-scroll-el="pdpContainer" />
    <div :class="{ 'fit-finder-container': $feature.showFitFinderOnPDP }">
      <slot name="notifications" />
      <transition name="fade">
        <div v-if="productPending && !product">
          <pdp-skeleton />
        </div>
        <div v-else-if="product">
          <div class="lg:mb-10 lg:flex lg:items-start">
            <section class="relative lg:grow" data-scroll-el="gallery">
              <slot name="gallery" />
            </section>
            <div
              v-style="{ w: { lg: '25.5rem' }, top: { lg: pxToRem(header.height.header) } }"
              class="px-4 pt-4 lg:sticky lg:top-0 lg:shrink-0 lg:pt-6"
            >
              <pdp-section-heading class="mb-2" is-drawer-expanded />
              <pdp-section-gift-card v-if="isDigitalProduct" />
              <pdp-section-variant-selection v-else />
              <slot name="espot-below-sizes" />
              <slot name="size-and-fit" />
              <slot name="klarna-payments" />
              <slot name="ctas" />
              <slot name="upsells" />
              <slot name="shipping-methods" />
            </div>
          </div>
          <div class="mt-4 <lg:mb-4 lg:mt-10">
            <div class="mb-8 px-4 lg:px-6">
              <slot name="accordions" />
              <slot name="espot-below-accordions" />
            </div>
            <slot name="shop-the-look" />
            <slot name="espot-lazy-above-footer" />
            <slot v-if="!product?.dummyCustoms" name="reviews" />
          </div>
        </div>
      </transition>
      <slot name="recommendations" />
    </div>
    <client-only>
      <teleport to="body">
        <slot name="body" />
      </teleport>
    </client-only>
    <slot />
  </main>
</template>

<script setup lang="ts">
import type { Slots } from '#commerce/types/pdp'

defineSlots<Slots>()

const header = useHeaderStore()
const { isDigitalProduct, product, productPending } = usePdp()
</script>
